export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/perfil', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
